import { render } from "./WorkloadPrepare.vue?vue&type=template&id=7ff24a58"
import script from "./WorkloadPrepare.vue?vue&type=script&lang=js"
export * from "./WorkloadPrepare.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__